import React from 'react';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';
import OverrideTable from 'components/core/fields/transformation_parameters/OverrideTable';
import TransformationParameter from 'components/core/fields/transformation_parameters/TransformationParameter';
import RIENumber from 'components/core/editable/RIENumber';
import InfoMessages from 'components/core/help/InfoMessages';
import ProcessUtils from 'utils/ProcessUtils';


export default class WidthParameter extends TransformationParameter {
    static defaultProps = {
        parameterNames: ['width'],
        isOverridable: true,
        isDefaultValueVisibleInitially: false,
        infoBoxText: InfoMessages.binWidth
    };

    renderQuestionText = () => {
        return 'Do you want to adjust the output bin width?';
    };

    renderDefaultComponent = () => {
        const fieldPath = this.getCoordinateSystemDefaultFieldPath();
        const value = this.getCoordinateSystemDefaultValue();
        const intervalValue = ProcessUtils.getDimensionInterval(this.props.process, this.props.coordinateSystemName, this.props.dimensionName);

        const labelStyles = css`
            white-space: nowrap;
            min-width: 70px;
            margin-right: 5px;
        `;

        const unitsLabel = ProcessUtils.getDimensionUnitsLabel(this.props.process.variable_retrieval.coordinate_systems[this.props.coordinateSystemName].dimensions[this.props.dimensionName]);

        return (
            <Flexbox flexDirection={'column'}>
                <Flexbox className={css`margin-bottom:5px;`}>
                    <label className={labelStyles}>Interval: </label>{intervalValue} {unitsLabel}
                </Flexbox>
                <Flexbox flexDirection={'row'}>
                    <label className={labelStyles}>
                        Bin Width:
                    </label>
                    <RIENumber
                        value={value}
                        change={this.onDefaultValueChange}
                        fieldPath={fieldPath}
                        processId={this.props.process.name}
                        processErrors={this.props.processErrors}
                        formDisplay
                        isDisabled={!this.props.hasWritePermissions}
                    />
                    <span className={css`padding-left:6px;`}>{unitsLabel}</span>
                </Flexbox>
            </Flexbox>
        );
    };

    renderOverrideTable = () => {
        return (
            <WidthOverrideTable
                process={this.props.process}
                parameterNames={this.props.parameterNames}
                coordinateSystemName={this.props.coordinateSystemName}
                dimensionName={this.props.dimensionName}
                processErrors={this.props.processErrors}
                hasWritePermissions={this.props.hasWritePermissions}
            />
        );
    }
}

class WidthOverrideTable extends OverrideTable {

    renderBinWidth = (data) => {
        const value = this.getValue(data);

        return (
            <RIENumber
                value={value}
                change={this.onValueChange}
                fieldPath={this.getFieldPath(this.props.parameterNames[0], data)}
                onChangeData={data}
                processId={this.props.process.name}
                processErrors={this.props.processErrors}
                formDisplay
                isDisabled={!this.props.hasWritePermissions}
            />
        );
    };

    getAdditionalColumns() {
        return ([
            {
                property: 'data',
                header: {
                    label: 'Bin Width',
                    props: {
                        style: {
                            whiteSpace: 'nowrap',
                        }
                    }
                },
                cell: {
                    formatters: [
                        data => { return this.renderBinWidth(data); }
                    ]
                }
            }
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/transformation_parameters/WidthParameter.js